// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b11bfef","455":"39eb85e3","977":"55041af9"}[chunkId] + ".chunk.js";
};